module.exports = __webpack_public_path__ + "img/vegetable-garlic-scapes-190x100.17fd31bd.jpg";